export const updateExperience = ({ BeURL, id, experience }) => {
    fetch(`${BeURL}/candidate-experience/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ experience }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                alert(data.message);
                setTimeout(()=>{
                    window.location.reload()
                }, [1000])
            } else {
                alert("Failed to update Experience: " + (data.message || "Unknown error"));
            }
        })
        .catch((err) => {
            console.log("Error in updating Experience", err);
        });
}
